import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

export const SearchBar = () => {
  return (
    <div className="relative flex w-full items-center">
      <Input
        type="text"
        placeholder="¿DÓNDE BUSCAMOS HOY?"
        className="pr-16 h-16 text-lg font-bold uppercase tracking-widest border-2 border-ink bg-parchment focus:ring-0 focus:border-terracotta rounded-none"
      />
      <Button
        size="icon"
        className="absolute right-0 h-16 w-16 bg-ink hover:bg-terracotta text-parchment rounded-none transition-colors border-l-2 border-ink"
      >
        <Search className="h-6 w-6" />
      </Button>
    </div>
  );
};